import { render, staticRenderFns } from "./FileAttacher.vue?vue&type=template&id=ac800b52&scoped=true&"
import script from "./FileAttacher.vue?vue&type=script&lang=ts&"
export * from "./FileAttacher.vue?vue&type=script&lang=ts&"
import style0 from "./FileAttacher.vue?vue&type=style&index=0&id=ac800b52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac800b52",
  null
  
)

export default component.exports